var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHkIcClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-Option-CardSystem-ShowOption-Copy",
    transform: "translate(-750.000000, -877.000000)",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Keyboard-Indication",
    transform: "translate(520.000000, 877.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close",
    transform: "translate(230.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy-3",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 23,
    height: 23,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25,11.25 L20,11.25 L20,13.75 L11.25,13.75 L11.25,16.25 L5,12.5 L11.25,8.75 L11.25,11.25 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#333333",
    transform: "translate(12.500000, 12.500000) rotate(-90.000000) translate(-12.500000, -12.500000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHkIcClose);
export default __webpack_public_path__ + "static/media/hkIcClose.8fef6e2b40b2b03cb0bb2b0dd4cf5898.svg";
export { ForwardRef as ReactComponent };